import { createSlice } from "@reduxjs/toolkit";
import { campaignManageApiSlice } from "./campaignManageApiSlice";

export const initialState = {
  query: {
    page: 1,
    size: 10,
  },
  one: {},
  selectedRetailers: [],
  selectedRetailerObj: {},
  officeType: [],
  errors: {},
};

const campaignManageSlice = createSlice({
  name: "campaignManage",
  initialState,
  reducers: {
    setQueryValue: (state, action) => {
      if (action.payload.key) {
        state.query[action.payload.key] = action.payload.value;
      } else {
        state.query = action.payload;
      }
    },
    setOneValue: (state, action) => {
      state.one[action.payload.key] = action.payload.value;
      if (state.errors?.[action.payload.key] !== "") {
        state.errors[action.payload.key] = "";
      }
    },
    clearOne: (state, action) => {
      state.one = initialState.one;
    },
    clearSelectedAccess: (state) => {
      state.selectedRetailerObj = initialState.selectedRetailerObj;
    },
    setSelectedRetailers: (state, { payload }) => {
      const { groupItems, key, Retailer, name } = payload;

      // Handle single item selection
      if (!groupItems && key) {
        const isSelected = state.selectedRetailers.includes(key);

        if (isSelected) {
          state.selectedRetailers = state.selectedRetailers.filter(
            (id) => id !== key
          );
          delete state.selectedRetailerObj[key];
        } else {
          state.selectedRetailers.push(key);
          state.selectedRetailerObj[key] = {
            id: Retailer || key,
            name: name || "",
            no_of_order: 0,
          };
        }
        return;
      }

      // Handle group selection
      if (groupItems && Array.isArray(groupItems)) {
        const groupIds = groupItems.map((item) => item._id);

        const allSelected = groupIds.every((id) =>
          state.selectedRetailers.includes(id)
        );

        if (allSelected) {
          state.selectedRetailers = state.selectedRetailers.filter(
            (id) => !groupIds.includes(id)
          );
          groupIds.forEach((id) => {
            delete state.selectedRetailerObj[id];
          });
        } else {
          groupItems.forEach((item) => {
            if (!state.selectedRetailers.includes(item._id)) {
              state.selectedRetailers.push(item._id);
              state.selectedRetailerObj[item._id] = {
                id: item._id,
                name: item.name,
                no_of_order: 0,
              };
            }
          });
        }
      }
    },

    setSelectAll: (state, { payload }) => {
      const allIds = payload.allKeys.map((item) => item._id);

      const isAlreadyFullySelected =
        Object.keys(state.selectedRetailerObj).length === allIds.length;

      if (isAlreadyFullySelected) {
        state.selectedRetailers = [];
        state.selectedRetailerObj = {};
      } else {
        state.selectedRetailers = allIds;
        state.selectedRetailerObj = payload.allKeys.reduce((acc, item) => {
          acc[item._id] = {
            id: item._id,
            name: item.name || "",
            no_of_order: item.no_of_order || 0,
          };
          return acc;
        }, {});
      }
    },

    updateRetailerOrder: (state, { payload }) => {
      const { id, no_of_order } = payload;
      if (state.selectedRetailerObj[id]) {
        state.selectedRetailerObj[id].no_of_order = no_of_order;
      }
    },
    // setBulkSelectedRetailers: (state, action) => {
    //   const newRetailers = action.payload;
    //   const newSelectedRetailers = [...state.selectedRetailers];
    //   const newSelectedRetailerObj = { ...state.selectedRetailerObj };

    //   newRetailers.forEach(({ key, Retailer, name }) => {
    //     if (!newSelectedRetailers.includes(key)) {
    //       newSelectedRetailers.push(key);
    //     }
    //     newSelectedRetailerObj[key] = {
    //       id: Retailer,
    //       name,
    //       no_of_order: newSelectedRetailerObj[key]?.no_of_order || 0
    //     };
    //   });

    //   state.selectedRetailers = newSelectedRetailers;
    //   state.selectedRetailerObj = newSelectedRetailerObj;
    // },

    setBulkRetailerOrders: (state, action) => {
      const { retailerIds, no_of_order, resetToZero = false } = action.payload;
      retailerIds.forEach((id) => {
        if (state.selectedRetailerObj[id]) {
          state.selectedRetailerObj[id].no_of_order = resetToZero
            ? 0
            : no_of_order;
        }
      });
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        campaignManageApiSlice.endpoints.loadOneCampaign.matchFulfilled,
        (state, { payload }) => {
          state.one = payload.data;
        }
      )
      .addMatcher(
        campaignManageApiSlice.endpoints.loadAllCampaignAccess.matchFulfilled,
        (state, { payload }) => {
          const officeList = payload.data.allowed_office || [];
          state.selectedRetailers = officeList.map((item) => item.office_id);
          state.selectedRetailerObj = officeList.reduce((acc, item) => {
            acc[item.office_id] = {
              id: item.office_id,
              no_of_order: item.no_of_order || 0,
            };
            return acc;
          }, {});
        }
      );

    builder.addMatcher(
      campaignManageApiSlice.endpoints.loadAllOfficeType.matchFulfilled,
      (state, { payload }) => {
        state.officeType = payload;
      }
    );
  },
});

export const {
  setQueryValue,
  setOneValue,
  clearOne,
  setSelectedRetailers,
  setSelectAll,
  clearSelectedAccess,
  updateRetailerOrder,
  setBulkSelectedRetailers,
  setBulkRetailerOrders,
} = campaignManageSlice.actions;

export default campaignManageSlice.reducer;
